import React from 'react';

/**
 * "This list couldn't be loaded" beside a picker.
 *
 * Row 128: a failed load used to come back as an empty list, so a picker read
 * "Select HMS Entity" with nothing in it, as if there were no companies to
 * choose. A screen that knows its list failed renders this next to the picker
 * instead, and keeps the rest of the form working. A list that loaded and is
 * genuinely empty keeps its own empty text; this is only for a failed load.
 *
 * Same look as row 124's notes on the Finance screens.
 */
const ListLoadFailed = ({ what, onRetry, className = '' }) => (
    <span
        role="alert"
        data-testid="list-load-failed"
        className={`list-load-failed ${className}`.trim()}
        style={{ color: '#b91c1c', fontSize: '0.8rem', display: 'inline-block', marginTop: 4 }}
    >
        Couldn&apos;t load {what}.{' '}
        {onRetry && (
            <button
                type="button"
                onClick={onRetry}
                style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    color: '#4a6b25',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    font: 'inherit',
                }}
            >
                Try again
            </button>
        )}
    </span>
);

export default ListLoadFailed;
